// ANGULAR DEPENDENCY
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

// CUSTOM MODULES
import { NotificationModule } from '../../../../modules/shared/components/modals/notification/notification.module';

// COMPONENTS
import { PopupNotificationComponent } from './popup-notification.component';

/**
 * This module is used for popup notification
 * For global popup notification purpose.
 *
 * @author Pratik Shihora <pratik@saeculumsolutions.com>
 *
 * Notes:-
 * Date: 16/03/2020 (Pratik Shihora <pratik@saeculumsolutions.com>) popup notification module created
 */
@NgModule({
  declarations: [PopupNotificationComponent],
  imports: [
    CommonModule,
    NotificationModule,
  ], exports: [PopupNotificationComponent],
})
export class PopupNotificationModule { }
